import { z } from "zod";

import { LeadEntityType } from "../../../lib/types/graphQLEnums";

export type CreateLeadFormInput = z.input<typeof createLeadSchema> & {
  stage?: string;
  noticeStage?: string;
};

export type CreateLeadFormOutput = z.output<typeof createLeadSchema> & {
  stage?: string;
  noticeStage?: string;
};

// Schema that will be used to create a lead, ensuring required fields are present
export const createLeadSchema = z.object({
  name: z.string().min(1, "Name is required"), // Ensures name is required
  description: z.string().optional(),
  value: z.coerce.number().nonnegative().optional(),
  stageId: z.uuid({ message: "Stage is required" }), // Ensures stage is required
  assignedToId: z.uuid().optional(),
  // transform the date object to a timestamp string
  expiryDate: z.coerce
    .date()
    .transform((date) => date.toISOString())
    .optional(),
  buyerIds: z.uuid().array().optional(),
  entities: z
    .object({
      entityId: z.uuid(),
      entityType: z.enum(LeadEntityType),
    })
    .array()
    .optional(),
});
